export default function ($translate) {
    return {
        KEYS: {
            COMPULSORY: 'COMPULSORY',
            OPTIONAL: 'OPTIONAL',
            EXCLUDED: 'EXCLUDED'
        },
        LABELS: {
            COMPULSORY: $translate.instant('course.target.Compulsory'),
            OPTIONAL: $translate.instant('course.target.optional'),
            EXCLUDED: $translate.instant('course.target.Excluded')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/target/needType/exception/index.js